import gql from 'graphql-tag';

export const SERVER_DELETE = gql`
  mutation ($id: ID!){
    serverDelete(id: $id) {
      id
    }
  }

`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/server/delete.js